import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable, throwError } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { TipoCuentaAbonoEnum } from 'src/app/global/enums/tipo-cuenta-abono.enum';
import { BancoResponse } from 'src/app/global/interfaces/banco-response';
import { CuentaAbonoRequest } from 'src/app/global/interfaces/cuenta-abono-request';
import { CuentaAbonoResponse } from 'src/app/global/interfaces/cuenta-abono.response';
import { Paso1 } from 'src/app/global/interfaces/paso-1';
import { Paso2 } from 'src/app/global/interfaces/paso-2';
import { CuentaAbonoService } from 'src/app/global/services/cuenta-abono.service';
import { LocalStorageService } from 'src/app/global/services/localstorage.service';
import { AnexoContratoServiceVM } from 'src/app/view-model/services/anexo-contrato.service';
import { BancoServiceVM } from 'src/app/view-model/services/banco-vm.service';
import { CuentaAbonoServiceVM } from 'src/app/view-model/services/cuenta-abono-vm.service';
import { RutFormatterService } from 'src/app/view-model/services/rut-formatter.service';
import { StepperServiceVM } from 'src/app/view-model/services/stepper-vm.service';
import { rutEmpresaValidator } from 'src/app/view-model/validators/rutempresa.validator';
import { rutGenericoValidator } from 'src/app/view-model/validators/rutgenerico.validator';


@Injectable()
export class CuentaAbonoProviderVM extends CuentaAbonoServiceVM {

  constructor(
    private cuentaAbonoService: CuentaAbonoService,
    private bancoServiceVM: BancoServiceVM,
    private stepperServiceVM: StepperServiceVM,
    private rutFormatter: RutFormatterService,
    private storage: LocalStorageService,
    private anexoContratoService: AnexoContratoServiceVM
  ) {
    super();
  }

  getCuentaAbono(): Observable<CuentaAbonoResponse> {
    return this.cuentaAbonoService.getCuentaAbono()
      .pipe(map(this.getCuentaAbonoOk), catchError(this.serviceError));
  }

  private getCuentaAbonoOk(resp) {
    return resp;
  }

  postCuentaAbono(formCuenta: FormGroup): Observable<any> {
    const rut = this.rutFormatter.getRutFormats(formCuenta.get('rutTitular').value).numbers;

    const datosCuenta: CuentaAbonoRequest = {
      run: this.rutFormatter.getRutFormats(formCuenta.get('rutTitular').value).numbers,
      nombres: {
        nombres: rut > 50000000 ? 'NO APLICA' : formCuenta.get('nombres').value,
        apellidoPaterno: rut > 50000000 ? 'NO APLICA' : formCuenta.get('primerApellido').value,
        apellidoMaterno: rut > 50000000 ? 'NO APLICA' : formCuenta.get('segundoApellido').value
      },
      razonSocial: rut > 50000000 ? formCuenta.get('nombres').value : formCuenta.get('nombres').value + ' ' + formCuenta.get('primerApellido').value + ' ' + formCuenta.get('segundoApellido').value,
      numero: formCuenta.get('numeroCuenta').value,
      idBanco: Number(formCuenta.get('banco').value),
      tipoCuenta: formCuenta.get('tipoCuentaBanco').value
    };

    return this.cuentaAbonoService.postCuentaAbono(datosCuenta)
      .pipe(map(this.postCuentaObonoOK), catchError(this.serviceError));

  }

  private postCuentaObonoOK(response) {
    return response;
  }

  private serviceError(error) {
    return throwError(error);
  }

  private saveCuentaAbono(datosCuenta: CuentaAbonoRequest): Observable<unknown> {
    return this.cuentaAbonoService.postCuentaAbono(datosCuenta)
      .pipe(map(this.postCuentaObonoOK), catchError(this.serviceError));
  }


  createForm(): FormGroup {
    const cuentaBancariaForm: FormGroup = new FormGroup({
      seleccionarCuenta: new FormControl(TipoCuentaAbonoEnum.CUENTA_PROPIA, [Validators.required])
    });
    cuentaBancariaForm.addControl('cuentaPropia', this.cuentaPropiaForm());
    cuentaBancariaForm.addControl('cuentaTercerosPN', this.cuentaTercerosFormPN());
    cuentaBancariaForm.addControl('cuentaEmpresaPN', this.cuentaEmpresaFormPN());

    this.loadForm(cuentaBancariaForm, true, false);
    return cuentaBancariaForm;
  }

  createFormPJ(): FormGroup {
    const form: FormGroup = new FormGroup({
      seleccionarCuenta: new FormControl(TipoCuentaAbonoEnum.CUENTA_EMPRESA, [Validators.required])
    });
    form.addControl('cuentaTerceros', this.cuentaTercerosForm());
    form.addControl('cuentaEmpresa', this.cuentaEmpresaForm());
    form.addControl('cuentaPropia', this.cuentaPropiaForm());
    this.loadForm(form, true, true);
    return form;
  }

  private cuentaPropiaForm(): FormGroup {
    return new FormGroup({
      rut: new FormControl('', [Validators.required]),
      nombresTitular: new FormControl('', [Validators.required]),
      primerApellido: new FormControl('', [Validators.required]),
      segundoApellido: new FormControl('', ),
      bancos: new FormControl('', [Validators.required]),
      tipoCuenta: new FormControl('', [Validators.required]),
      numeroCuenta: new FormControl('', [Validators.required]),
      autorizar: new FormControl('', [Validators.requiredTrue]),
      seleccionarCuenta: new FormControl(TipoCuentaAbonoEnum.CUENTA_PROPIA, [Validators.required])
    });
  }

  private cuentaTercerosFormPN(): FormGroup {
    return new FormGroup({
      rut: new FormControl('', [Validators.required,rutGenericoValidator]),
      nombresTitular: new FormControl('', [Validators.required]),
      primerApellido: new FormControl('', [Validators.required]),
      segundoApellido: new FormControl('', ),
      bancos: new FormControl('', [Validators.required]),
      tipoCuenta: new FormControl('', [Validators.required]),
      numeroCuenta: new FormControl('', [Validators.required]),
      autorizar: new FormControl('', [Validators.requiredTrue]),
      seleccionarCuenta: new FormControl(TipoCuentaAbonoEnum.CUENTA_TERCEROS, [Validators.required])
    });
  }

  private cuentaTercerosForm(): FormGroup {
    return new FormGroup({
      rutEmpresa: new FormControl('', [
        Validators.required,
        rutGenericoValidator
      ]),
      nombresTitular: new FormControl('', [Validators.required]),
      primerApellido: new FormControl('', [Validators.required]),
      segundoApellido: new FormControl('', ),
      razonSocial:  new FormControl('', [Validators.required]),
      bancos: new FormControl('', [Validators.required]),
      tipoCuenta: new FormControl('', [Validators.required]),
      numeroCuenta: new FormControl('', [Validators.required]),
      autorizar: new FormControl('', [Validators.requiredTrue]),
      seleccionarCuenta: new FormControl(TipoCuentaAbonoEnum.CUENTA_TERCEROS, [Validators.required])
    });
  }

  private cuentaEmpresaFormPN(): FormGroup {
    return new FormGroup({
      rut: new FormControl('', [
        Validators.required
      ]),
      nombresTitular: new FormControl('', [Validators.required]),
      primerApellido: new FormControl(''),
      segundoApellido: new FormControl(''),
      razonSocial: new FormControl(''),
      bancos: new FormControl('', [Validators.required]),
      tipoCuenta: new FormControl('', [Validators.required]),
      numeroCuenta: new FormControl('', [Validators.required]),
      autorizar: new FormControl('', [Validators.requiredTrue]),
      seleccionarCuenta: new FormControl(TipoCuentaAbonoEnum.CUENTA_EMPRESA, [Validators.required])

    });
  }

  private cuentaEmpresaForm(): FormGroup {
    return new FormGroup({
      rutEmpresa: new FormControl('', [
        Validators.required, rutEmpresaValidator
      ]),
      nombresTitular: new FormControl(''),
      primerApellido: new FormControl(''),
      segundoApellido: new FormControl(''), 
      razonSocial: new FormControl('', [Validators.required]),
      bancos: new FormControl('', [Validators.required]),
      tipoCuenta: new FormControl('', [Validators.required]),
      numeroCuenta: new FormControl('', [Validators.required]),
      autorizar: new FormControl('', [Validators.requiredTrue]),
      seleccionarCuenta: new FormControl(TipoCuentaAbonoEnum.CUENTA_EMPRESA, [Validators.required])

    });
  }

  async loadForm(cuentaBancariaForm: FormGroup, precarga = true, isPJ: boolean): Promise<void> {
    const paso1: Paso1 = this.storage.getPaso1();
    const paso2: Paso2 = this.storage.getPaso2();
    const runFinal = paso1.run + '';

    if (!isPJ) {
      if (paso2.datosPersonales) {

        const data: CuentaAbonoResponse = {
          run: paso1.run,
          nombre: paso2.datosPersonales.nombres,
          numero: null,
          razonSocial: 'a',
          banco: {
            relacion: [],
            id: 1,
            asString: ''
          },
          tipoPropietario: '',
          comercioInformal: null
        };
        if (this.esFormCuentaPropia(cuentaBancariaForm) || precarga === false) {

          const rutTitularControl = cuentaBancariaForm.get('rut');
          if (rutTitularControl) {
            rutTitularControl.setValue(this.rutFormatter.format(runFinal));  // Formatea y establece el valor
          } else {
            console.error('El control rut no está presente en el formulario');
          }

          const nombresTitularControl = cuentaBancariaForm.get('nombresTitular');
          nombresTitularControl.setValue(data.nombre.nombres);

          const primerApellidoControl = cuentaBancariaForm.get('primerApellido');
          primerApellidoControl.setValue(data.nombre.apellidoPaterno);

          const segundoApellidoControl = cuentaBancariaForm.get('segundoApellido');
          segundoApellidoControl.setValue(data.nombre.apellidoMaterno);
        } else {
          const cuentaTercerosForm = cuentaBancariaForm.get('cuentaTerceros') as FormGroup;
          cuentaTercerosForm.reset();
          const rutTitularControl = cuentaTercerosForm.get('rutEmpresa');
          rutTitularControl.setValue(data.run);

          const nombresTitularControl = cuentaTercerosForm.get('nombresTitular');
          nombresTitularControl.setValue(data.nombre.nombres);

          const primerApellidoControl = cuentaTercerosForm.get('primerApellido');
          primerApellidoControl.setValue(data.nombre.apellidoPaterno);

          const segundoApellidoControl = cuentaTercerosForm.get('segundoApellido');
          segundoApellidoControl.setValue(data.nombre.apellidoMaterno);
        }
      }
    } else {
      if (paso2.datosComercio) {
        const data: CuentaAbonoResponse = {
          run: paso1.run,
          nombre: null,
          numero: null,
          razonSocial: paso2.datosComercio.razonSocial,
          banco: {
            relacion: [],
            id: 1,
            asString: ''
          },
          tipoPropietario: '',
          comercioInformal: null
        };
        if (this.esFormCuentaEmpresa(cuentaBancariaForm) || precarga === false) {
          // Obtenemos el sub‐FormGroup “cuentaEmpresa”
          const cuentaEmpresaGroup = cuentaBancariaForm.get('cuentaEmpresa') as FormGroup;
          if (!cuentaEmpresaGroup) {
            console.error('El sub-formulario "cuentaEmpresa" no existe en el formulario padre');
          } else {
            // 1) Formatea y asigna el RUT de la empresa
            const rutEmpresaControl = cuentaEmpresaGroup.get('rutEmpresa');
            if (rutEmpresaControl) {
              rutEmpresaControl.setValue(this.rutFormatter.format(runFinal));
            } else {
              console.warn('Control "rutEmpresa" no encontrado en cuentaEmpresaGroup');
            }
        
            // 2) Asigna la razón social
            const razonSocialControl = cuentaEmpresaGroup.get('razonSocial');
            if (razonSocialControl) {
              razonSocialControl.setValue(data.razonSocial);
            } else {
              console.warn('Control "razonSocial" no encontrado en cuentaEmpresaGroup');
            }
          }
        }else {
          const cuentaTercerosForm = cuentaBancariaForm as FormGroup;
          cuentaTercerosForm.reset();
          const rutTitularControl = cuentaTercerosForm.get('rut');
          rutTitularControl.setValue(data.run);

          const nombresTitularControl = cuentaTercerosForm.get('nombresTitular');
          nombresTitularControl.setValue(data.nombre.nombres);

          const primerApellidoControl = cuentaTercerosForm.get('primerApellido');
          primerApellidoControl.setValue(data.nombre.apellidoPaterno);

          const segundoApellidoControl = cuentaTercerosForm.get('segundoApellido');
          segundoApellidoControl.setValue(data.nombre.apellidoMaterno);
        }
      }
    }
  }

  bancos(): Observable<BancoResponse[]> {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    return this.bancoServiceVM.getBancos().pipe(tap(() => { }));
  }

  async saveForm(cuentaBancariaForm: FormGroup): Promise<any> {
    if (this.esFormCuentaPropia(cuentaBancariaForm)) {
      const resp = await this.saveCuentaPropia(cuentaBancariaForm);
      return resp;
    } else if (this.esFormCuentaEmpresa(cuentaBancariaForm)) {
      const resp = await this.saveCuentaEmpresa(cuentaBancariaForm);
      return resp;
    } else {
      const resp = await this.saveCuentaTerceros(cuentaBancariaForm);
      return resp;
    }
  }

  private async saveCuentaEmpresa(cuentaBancariaForm: FormGroup): Promise<unknown> {
    const cuentaEmpresaFormJSON = cuentaBancariaForm.value;
  
    try {
      const razonSocial = cuentaEmpresaFormJSON.razonSocial || cuentaEmpresaFormJSON.nombresTitular;
  
      const datosCuenta: CuentaAbonoRequest = {
        run: this.rutFormatter.getRutFormats(cuentaEmpresaFormJSON.rutEmpresa || cuentaEmpresaFormJSON.rut).numbers,
        nombres: null,
        razonSocial: razonSocial,
        numero: cuentaEmpresaFormJSON.numeroCuenta,
        idBanco: cuentaEmpresaFormJSON.bancos,
        tipoCuenta: cuentaEmpresaFormJSON.tipoCuenta
      };
  
      const response = await this.saveCuentaAbono(datosCuenta).toPromise();
      return response;
    } catch (exception) {
      console.error('Error al guardar cuenta', exception);
      return exception;
    } finally {
      // this.stepperServiceVM.nextStep();
    }
  }
  

  private async saveCuentaPropia(cuentaBancariaForm: FormGroup): Promise<unknown> {

    const cuentaPropiaFormJSON = cuentaBancariaForm.value;

    try {
      const datosCuenta: CuentaAbonoRequest = {
        run: this.rutFormatter.getRutFormats(cuentaPropiaFormJSON.rut).numbers,
        nombres: {
          nombres: cuentaPropiaFormJSON.nombresTitular,
          apellidoPaterno: cuentaPropiaFormJSON.primerApellido,
          apellidoMaterno: cuentaPropiaFormJSON.segundoApellido
        },
        razonSocial: null,
        numero: cuentaPropiaFormJSON.numeroCuenta,
        idBanco: cuentaPropiaFormJSON.bancos,
        tipoCuenta: cuentaPropiaFormJSON.tipoCuenta
      };
      const response = await this.saveCuentaAbono(datosCuenta).toPromise();
      return response;
    } catch (exception) {
      console.error('Error al guardar cuenta', exception);
      return exception;
    } finally {
      // this.stepperServiceVM.nextStep();
    }
  }

  private async saveCuentaTerceros(cuentaBancariaForm: FormGroup): Promise<any> {

    const cuentaTercerosFormJSON = cuentaBancariaForm.value;

    try {
      const rut = this.rutFormatter.getRutFormats(cuentaTercerosFormJSON.rutEmpresa || cuentaTercerosFormJSON.rut).numbers;
     
      const nombres = cuentaTercerosFormJSON.razon + ' ' +
        cuentaTercerosFormJSON.primerApellido + ' ' + cuentaTercerosFormJSON.segundoApellido;
      const datosCuenta: CuentaAbonoRequest = {
        run: rut,
        nombres: {
          nombres: rut > 50000000 ? 'NO APLICA' : cuentaTercerosFormJSON.nombresTitular || cuentaTercerosFormJSON.razon,
          apellidoPaterno: rut > 50000000 ? 'NO APLICA' : cuentaTercerosFormJSON.primerApellido,
          apellidoMaterno: rut > 50000000 ? 'NO APLICA' : cuentaTercerosFormJSON.segundoApellido
        },
        razonSocial: rut > 50000000 ? cuentaTercerosFormJSON.nombresTitular : nombres,
        numero: cuentaTercerosFormJSON.numeroCuenta,
        idBanco: Number(cuentaTercerosFormJSON.bancos),
        tipoCuenta: cuentaTercerosFormJSON.tipoCuenta
      };
      const response = await this.saveCuentaAbono(datosCuenta).toPromise();
      return response;
    } catch (exception) {
      console.error('Error al guardar cuenta', exception);
      return exception;
    } finally {
      // this.stepperServiceVM.nextStep();
    }
  }

  private esFormCuentaPropia(cuentaBancariaForm: FormGroup) {
    const tipoCuenta = cuentaBancariaForm.get('seleccionarCuenta') ? cuentaBancariaForm.get('seleccionarCuenta').value : '';
    let esCuentaPropia = false;
    if (tipoCuenta === TipoCuentaAbonoEnum.CUENTA_PROPIA) {
      esCuentaPropia = true;
    }
    return esCuentaPropia;
  }

  private esFormCuentaEmpresa(cuentaBancariaForm: FormGroup) {
    const tipoCuenta = cuentaBancariaForm.get('seleccionarCuenta') ? cuentaBancariaForm.get('seleccionarCuenta').value : '';
    let esCuentaEmpresa = false;
    if (tipoCuenta === TipoCuentaAbonoEnum.CUENTA_EMPRESA) {
      esCuentaEmpresa = true;
    }
    return esCuentaEmpresa;
  }

  postCuentaAbonoPaso3(form: FormGroup): Observable<any> {
    let cuentaAbono: CuentaAbonoResponse;
    let tipoAprobacion: string;

    const cbSaveOK = () => {
      return this.anexoContratoService.getTipoAprobacion();
    };

    const cbTipoAprobacion = response => {
      tipoAprobacion = response.tipoAprobacion;
      return this.getCuentaAbono();
    };

    const cbGetOK = response => {
      cuentaAbono = response;
      const returnMessage = {
        cuentaAbono,
        tipoAprobacion
      };

      return returnMessage;
    };

    const cbError = error => {
      return throwError(error);
    };

    return this.postCuentaAbono(form)
      .pipe(mergeMap(cbSaveOK))
      .pipe(mergeMap(cbTipoAprobacion))
      .pipe(map(cbGetOK))
      .pipe(catchError(cbError));

  }
}
